export default {"src":"/_next/static/media/icon-passion.cb1535d3.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};